<template>
  <header class="header">
    <div class="container">
      <div class="header-content">
        <!-- Logo区域 -->
        <div class="logo">
          <router-link to="/" class="logo-link">
            <img src="@/assets/images/logo white.png" alt="久朋" class="logo-image">
          </router-link>
        </div>
        
        <!-- 汉堡菜单按钮 -->
        <button 
          class="navbar-toggler" 
          @click="toggleNavbar"
          :class="{ 'collapsed': !isNavbarOpen, 'hidden': isNavbarOpen }"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        
        <!-- 导航菜单 -->
        <nav class="navbar-collapse" :class="{ 'show': isNavbarOpen }">
          <!-- 手机端关闭按钮 -->
          <button 
            class="navbar-close" 
            @click="closeNavbar"
            aria-label="Close navigation"
            type="button"
          >
            <span class="navbar-close-icon">×</span>
          </button>
          
          <!-- 手机端Logo显示 -->
          <div class="mobile-logo">
            <img src="@/assets/images/logo white.png" alt="久朋" class="mobile-logo-image">
          </div>
          
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link to="/" class="nav-link" exact @click="closeNavbar">首页</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/company-profile" class="nav-link" @click="closeNavbar">公司简介</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/news-center" class="nav-link" @click="closeNavbar">新闻中心</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/feature-intro" class="nav-link" @click="closeNavbar">功能介绍</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'JpHeader',
  data() {
    return {
      isNavbarOpen: false
    }
  },
  methods: {
    toggleNavbar() {
      this.isNavbarOpen = !this.isNavbarOpen;
      console.log('导航状态:', this.isNavbarOpen);
      
      // 确保汉堡菜单按钮在导航展开时被隐藏
      if (this.isNavbarOpen) {
        this.$nextTick(() => {
          const toggler = this.$el.querySelector('.navbar-toggler');
          if (toggler) {
            toggler.style.display = 'none';
          }
        });
      }
    },
    closeNavbar() {
      this.isNavbarOpen = false;
      console.log('关闭导航');
      
      // 恢复汉堡菜单按钮显示
      this.$nextTick(() => {
        const toggler = this.$el.querySelector('.navbar-toggler');
        if (toggler) {
          toggler.style.display = 'block';
        }
      });
    }
  },
  watch: {
    // 监听路由变化，自动关闭导航
    '$route'() {
      this.closeNavbar();
    }
  },
  mounted() {
    // 监听窗口大小变化，自动关闭导航栏
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        this.isNavbarOpen = false;
      }
    });
  }
}
</script>

<style scoped>
/* CSS重置，确保全屏显示 */
* {
  box-sizing: border-box;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  position: relative;
}

/* Logo样式 */
.logo-link {
  display: block;
  text-decoration: none;
  z-index: 1001;
}

.logo-image {
  height: 40px;
  width: auto;
  transition: transform 0.3s ease;
}

.logo-image:hover {
  transform: scale(1.05);
}

/* 汉堡菜单按钮 */
.navbar-toggler {
  display: none;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  z-index: 1001;
  transition: all 0.3s ease;
  width: 30px;
  height: 30px;
  position: relative;
}

/* 汉堡菜单按钮隐藏状态 */
.navbar-toggler.hidden {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

.navbar-toggler:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.25);
}

.navbar-toggler-icon {
  display: block;
  width: 20px;
  height: 2px;
  background-color: #333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease;
}

.navbar-toggler-icon::before,
.navbar-toggler-icon::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 2px;
  background-color: #333;
  transition: all 0.3s ease;
  left: 0;
}

.navbar-toggler-icon::before {
  top: -6px;
}

.navbar-toggler-icon::after {
  bottom: -6px;
}

/* 汉堡菜单动画 */
.navbar-toggler.collapsed .navbar-toggler-icon {
  background-color: #333;
}

.navbar-toggler.collapsed .navbar-toggler-icon::before {
  top: -6px;
  transform: rotate(0deg);
}

.navbar-toggler.collapsed .navbar-toggler-icon::after {
  bottom: -6px;
  transform: rotate(0deg);
}

.navbar-toggler:not(.collapsed) .navbar-toggler-icon {
  background-color: transparent;
}

.navbar-toggler:not(.collapsed) .navbar-toggler-icon::before {
  top: 0;
  transform: rotate(45deg);
}

.navbar-toggler:not(.collapsed) .navbar-toggler-icon::after {
  bottom: 0;
  transform: rotate(-45deg);
}

/* 桌面端隐藏手机端元素 */
.mobile-logo,
.navbar-close {
  display: none !important; /* 强制隐藏 */
}

/* 桌面端隐藏汉堡菜单按钮 */
.navbar-toggler {
  display: none !important;
}

/* 桌面端显示水平导航 */
.navbar-collapse {
  display: flex;
  align-items: center;
}

.navbar-nav {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 30px;
}

.nav-item {
  margin: 0;
}

.nav-link {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
  padding: 8px 0;
  display: block;
}

.nav-link:hover,
.nav-link.router-link-active {
  color: #ff6b35;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #ff6b35;
  transition: width 0.3s ease;
}

.nav-link:hover::after,
.nav-link.router-link-active::after {
  width: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
  
  /* 手机端显示汉堡菜单按钮 */
  .navbar-toggler {
    display: block !important;
  }
  
  /* 手机端隐藏桌面端水平导航 */
  .navbar-collapse {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(15px);
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 1000;
    padding-top: 20px; /* 减少顶部间距 */
    overflow-y: auto; /* 允许滚动 */
    width: 100vw; /* 确保全屏宽度 */
    height: 100vh; /* 确保全屏高度 */
    -webkit-overflow-scrolling: touch; /* iOS滚动优化 */
  }
  
  .navbar-collapse.show {
    transform: translateX(0);
  }
  
  /* 手机端Logo显示 */
  .mobile-logo {
    margin-bottom: 40px;
    text-align: center;
    margin-top: 60px; /* 为顶部导航栏留出空间 */
    flex-shrink: 0; /* 防止Logo被压缩 */
    display: block !important; /* 强制显示 */
  }
  
  .mobile-logo-image {
    height: 50px;
    width: auto;
  }
  
  /* 手机端导航菜单样式 */
  .navbar-nav {
    flex-direction: column;
    gap: 0;
    width: 100%;
    text-align: center;
    padding: 0;
    margin: 0;
    flex: 1; /* 占据剩余空间 */
    min-height: 0; /* 允许内容收缩 */
  }
  
  .nav-item {
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    background: rgba(255, 255, 255, 0.9); /* 增强背景 */
  }
  
  .nav-item:last-child {
    border-bottom: none;
  }
  
  .nav-link {
    font-size: 18px;
    padding: 20px;
    width: 100%;
    border-radius: 0;
    color: #333;
    font-weight: 500;
    display: block;
    text-decoration: none;
  }
  
  .nav-link:hover,
  .nav-link.router-link-active {
    background-color: rgba(255, 107, 53, 0.15);
    color: #ff6b35;
  }
  
  .nav-link::after {
    display: none;
  }
  
  /* 手机端Logo调整 */
  .logo-image {
    height: 35px;
  }
  
  /* 手机端关闭按钮 - 确保只有一个 */
  .navbar-close {
    position: fixed !important; /* 强制固定定位 */
    top: 20px !important;
    right: 20px !important;
    background: none !important;
    border: none !important;
    font-size: 32px !important;
    color: #333 !important;
    cursor: pointer !important;
    padding: 0 !important;
    width: 40px !important;
    height: 40px !important;
    display: flex !important; /* 强制显示 */
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50% !important;
    transition: all 0.3s ease !important;
    z-index: 1001 !important;
    margin: 0 !important;
    line-height: 1 !important;
  }
  
  .navbar-close:hover {
    background-color: rgba(0, 0, 0, 0.1) !important;
    color: #ff6b35 !important;
  }
  
  .navbar-close:focus {
    outline: none !important;
    box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.25) !important;
  }
  
  .navbar-close-icon {
    line-height: 1 !important;
    font-weight: bold !important;
    display: block !important;
  }
}

/* 超小屏幕优化 */
@media (max-width: 480px) {
  .header-content {
    height: 55px;
  }
  
  .logo-image {
    height: 30px;
  }
  
  .navbar-toggler {
    padding: 6px;
    width: 28px;
    height: 28px;
  }
  
  .navbar-toggler-icon {
    width: 18px;
  }
  
  .navbar-toggler-icon::before,
  .navbar-toggler-icon::after {
    width: 18px;
  }
  
  .nav-link {
    font-size: 16px;
    padding: 18px;
  }
  
  /* 超小屏幕导航调整 */
  .navbar-collapse {
    padding-top: 15px;
    width: 100vw;
    height: 100vh;
  }
  
  /* 超小屏幕Logo调整 */
  .mobile-logo-image {
    height: 40px;
  }
  
  .mobile-logo {
    margin-bottom: 30px;
    margin-top: 50px; /* 调整顶部间距 */
  }
  
  /* 超小屏幕关闭按钮调整 */
  .navbar-close {
    top: 15px !important;
    right: 15px !important;
    font-size: 28px !important;
    width: 35px !important;
    height: 35px !important;
  }
}
</style>